import { motion } from 'framer-motion'
import { Code2, Database, Brain, BookOpen } from 'lucide-react'
import SectionHeader from './SectionHeader'

const facts = [
  { title: 'Full-stack development', icon: Code2 },
  { title: 'AI-powered applications', icon: Brain },
  { title: 'Data visualization', icon: Database },
  { title: 'Research-oriented thinking', icon: BookOpen }
]

const About = () => {
  return (
    <section id="about" className="section-shell py-20 md:py-24">
      <div className="grid gap-12 lg:grid-cols-[0.75fr_1.25fr]">
        <SectionHeader kicker="About" title="A technical profile shaped by systems, people, and research." />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55 }}
        >
          <p className="text-xl leading-9 text-academic-text">
            I am a software developer with a strong interest in building reliable, human-centered systems. My work combines full-stack engineering, data-driven thinking, and AI-powered product development.
          </p>
          <p className="mt-5 leading-8 text-academic-muted">
            I approach software as both an engineering discipline and a communication tool: systems should be maintainable, thoughtful, accessible, and clear enough for people to trust.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {facts.map(({ title, icon: Icon }) => (
              <div key={title} className="card flex items-center gap-4 p-5 transition hover:-translate-y-1 hover:border-academic-blue">
                <span className="rounded-2xl bg-academic-soft p-3 text-academic-blue">
                  <Icon size={20} />
                </span>
                <p className="font-semibold text-academic-text">{title}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default About
